<template>
  <div class="customer-common">
    <div :style="textInfo">
      <p class="text-dark font-size-h5 font-weight-bold">
        Thông tin khách hàng
      </p>
    </div>
    <b-row>
      <b-col md="4">
        <b-form-group>
          <label>Điện thoại:<b class="text-danger">*</b> </label>
          <i
            v-show="customerModel.customerId"
            @click="showPopoverCustomer = !showPopoverCustomer"
            class="far fa-caret-square-down text-warning ml-2"
            id="popover-button-sync"
            style="cursor: pointer"
          ></i>

          <Autosuggest
            :model="customerModel.customerMobile"
            :suggestions="filteredOptionsCustomer"
            :suggestionName="'phoneNo'"
            placeholder="số điện thoại"
            :limit="10"
            @select="onSelectCustomer"
            @change="onSearchChange"
          >
            <template #custom="{ suggestion }">
              <div>
                <div class="d-flex flex-column">
                  <span class="text-primary mb-1" v-if="suggestion.item.phoneNo"
                    >({{ suggestion.item.phoneNo }})</span
                  >
                  <span v-if="suggestion.item.fullName">{{
                    suggestion.item.fullName
                  }}</span>
                  <span v-else>{{ suggestion.item.message }}</span>
                </div>
              </div>
            </template>
          </Autosuggest>
          <b-form-invalid-feedback
            :state="validateCustomer"
            id="input-phone-live-feedback"
            >Vui lòng nhập số điện thoại hợp lệ!</b-form-invalid-feedback
          >
        </b-form-group>
      </b-col>
      <b-col md="4">
        <b-form-group>
          <label>
            Họ và tên:<b class="text-danger">*</b>
            <span class="text-primary" v-html="pointText"></span>
          </label>
          <b-form-input
            class="input-style"
            size="sm"
            type="text"
            v-model="customerModel.customerName"
            placeholder="Tên khách hàng"
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col md="4">
        <b-form-group>
          <label>Địa chỉ:</label
          ><b-form-input
            class="input-style"
            size="sm"
            type="text"
            v-model="customerModel.customerAddress"
            placeholder="Địa chỉ khách hàng"
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="4">
        <b-form-group>
          <label>Thành phố:</label>
          <treeselect
            :options="listCity"
            :multiple="false"
            placeholder="Chọn thành phố"
            noResultsText="Không có kết quả"
            :match-keys="['label', 'custom']"
            v-model="customerModel.customerCity"
            openDirection="bottom"
          >
          </treeselect>
        </b-form-group>
      </b-col>
      <b-col md="4">
        <b-form-group>
          <label>Quận huyện:</label>
          <treeselect
            :options="listDistrict"
            :multiple="false"
            placeholder="Chọn tỉnh thành"
            noResultsText="Không có kết quả"
            :match-keys="['label', 'custom']"
            v-model="customerModel.customerDistrict"
            openDirection="bottom"
            :disabled="listDistrict.length ? false : true"
          >
          </treeselect>
        </b-form-group>
      </b-col>
      <b-col md="4">
        <b-form-group>
          <label>Phường xã:</label>
          <treeselect
            :options="listWard"
            :multiple="false"
            placeholder="Chọn phường xã"
            noResultsText="Không có kết quả"
            :match-keys="['label', 'custom']"
            v-model="customerModel.customerWard"
            openDirection="bottom"
            :disabled="listWard.length ? false : true"
          >
          </treeselect>
        </b-form-group>
      </b-col>
    </b-row>
    <b-form-group>
      <b-form-checkbox v-model="customerModel.isExportInvoice">
        Xuất hóa đơn
      </b-form-checkbox>
    </b-form-group>
    <b-collapse :visible="customerModel.isExportInvoice" class="mt-3">
      <div :style="textInfo">
        <p class="text-dark font-size-h5 font-weight-bold">
          Thông tin xuất hóa đơn
        </p>
      </div>
      <b-row>
        <b-col md="4">
          <b-form-group>
            <label for="input-tax-no">Mã số thuế:</label>
            <b-form-input
              tabindex="6"
              v-model.trim="customerModel.customerTaxNo"
              placeholder="Nhập MST"
              aria-describedby="input-tax-no-feedback"
              size="sm"
            />
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group>
            <label for="input-tax-no">Tên công ty/ cá nhân:</label>
            <b-form-input
              tabindex="6"
              v-model.trim="customerModel.customerTaxName"
              placeholder="Nhập tên công ty/ cá nhân"
              aria-describedby="input-tax-no-feedback"
              size="sm"
            />
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group>
            <label for="input-tax-no">Địa chỉ xuất hóa đơn:</label>
            <b-form-input
              tabindex="6"
              v-model.trim="customerModel.customerTaxAddress"
              placeholder="Nhập địa chỉ xuất hóa đơn"
              aria-describedby="input-tax-no-feedback"
              size="sm"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-collapse>
    <div>
      <div>
        <b-popover
          :show.sync="showPopoverCustomer"
          target="popover-button-sync"
          title="Lịch sử khách hàng"
          triggers="hover focus"
          id="popover-customer"
        >
          <div>
            <a
              @click="copyCustomerMobile"
              class="mt-1 d-block"
              v-if="customerModel.customerMobile.length > 8"
              ><b class="text-dark">Số điện thoại :</b>
              {{ customerModel.customerMobile }}
              <i
                class="far fa-copy text-primary cursor-pointer ml-1"
                style="font-size: 0.85rem"
              ></i>
            </a>
            <a href="#" class="mt-1 d-block"
              ><b class="text-dark">Đơn hàng :</b>
              {{ customerTransaction.orderCount }}</a
            >
            <a href="#" class="mt-1 d-block"
              ><b class="text-dark">Bán lẻ :</b>
              {{ customerTransaction.retailCount }}</a
            >
            <a href="#" class="mt-1 d-block"
              ><b class="text-dark">Bán buôn:</b>
              {{ customerTransaction.wholesaleCount }}</a
            >
            <a href="#" class="mt-1 d-block"
              ><b class="text-dark">Trả hàng:</b>
              {{ customerTransaction.refundCount }}</a
            >
            <a href="#" class="mt-1 d-block"
              ><b class="text-dark">Công nợ:</b>
              {{ convertPrice(customerTransaction.customerDebt) }}</a
            >
          </div>
          <div class="mt-3 text-center">
            <span class="text-link" @click="viewCustomerTransaction"
              >Chi tiết</span
            >
          </div>
        </b-popover>
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from '@/core/services/api.service';
import { CUSTOMER_TYPE } from '@/utils/constants';
import { cloneDeep, isEmpty } from 'lodash';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import { ASYNC_SEARCH } from '@riophae/vue-treeselect';
import { removeAccents, copyClipBoard, convertPrice } from '@/utils/common';
import Autosuggest from '@/view/base/auto-sugguest/AutoSuggest.vue';
import { TIME_TRIGGER } from '@/utils/constants';
import { ORDER_STATUS } from '@/utils/enum';
import decounce from 'debounce';
import { mapGetters } from 'vuex';

export default {
  props: ['onSubmiting', 'billData', 'action'],
  data() {
    return {
      customerModel: {
        customerId: null,
        customerMobile: '',
        customerName: '',
        customerLastName: '',
        customerAddress: '',
        customerCity: null,
        customerDistrict: null,
        customerWard: null,
        customerType: 1,
        customerTaxNo: '',
        customerTaxName: '',
        customerTaxAddress: '',
        totalPoint: 0,
        isExportInvoice: false,
      },
      optionsCustomerType: [],
      showPopoverCustomer: false,
      defaultOptionCustomers: null,
      skipLoaded: false,
      isOpenCustomerSearch: false,
      customerTransaction: {
        orderCount: 0,
        retailCount: 0,
        wholesaleCount: 0,
        refundCount: 0,
        customerDebt: 0,
      },
      filteredOptionsCustomer: [],
      optionsCustomer: [],
      listCity: [],
      listDistrict: [],
      listWard: [],
      textInfo: {
        alignItems: 'center',
        display: 'flex',
        marginTop: '8px',
      },
    };
  },
  components: {
    Treeselect,
    Autosuggest,
  },
  computed: {
    ...mapGetters(['getOrderCustomerInfo']),
  },
  mounted() {
    this.customerModel = cloneDeep(this.billData.customerModel);
    this.getCustomerInfoUpdatedById(this.customerModel.customerId);
  },
  created() {
    this.mappingEnum();
    this.fetchCity();
    if (this.action === 'update') {
      const customerModel = this.getOrderCustomerInfo;
      this.defaultOptionCustomers = [
        {
          id: customerModel.customerId,
          label: customerModel.customerMobile,
          customLabel: customerModel.customerName,
        },
      ];
      this.customerModel = customerModel;
      this.getCustomerInfoUpdatedById(this.customerModel.customerId);
    }
    this.$nextTick(() => {
      this.skipLoaded = true;
    });
  },
  watch: {
    'customerModel.customerCity': function (city) {
      if (this.skipLoaded) {
        this.listDistrict = [];
        this.listWard = [];
        this.customerModel.customerDistrict = null;
        this.customerModel.customerWard = null;
        if (city) {
          this.getDistrict();
        }
      }
    },
    'customerModel.customerDistrict': function (district) {
      if (this.skipLoaded) {
        this.listWard = [];
        this.customerModel.customerWard = null;
        if (district) {
          this.getWard();
        }
      }
    },
    customerModel: {
      handler: function (value, oldValue) {
        if (this.skipLoaded) {
          this.$emit('onUpdate', value);
        }
        if (!oldValue) {
          this.getTransactionByCustomerId(value.customerId);
        } else if (oldValue && value !== oldValue) {
          this.getTransactionByCustomerId(value.customerId);
        }
      },
      deep: true,
    },
  },
  methods: {
    convertPrice,
    debounceInput: decounce(function () {
      this.getListCustomer();
    }, TIME_TRIGGER),
    mappingEnum() {
      this.optionsCustomerType = cloneDeep(CUSTOMER_TYPE).reduce(
        (result, element) => {
          if (element.value !== null) {
            result.push({
              id: element.id,
              label: element.name,
              custom: removeAccents(element.name),
            });
          }
          return result;
        },
        [],
      );
    },
    copyCustomerMobile() {
      const customerMobile = this.customerModel.customerMobile || '';
      if (customerMobile.length > 8) {
        copyClipBoard(customerMobile, 'Số điện thoại');
      }
    },
    onSelectCustomer(option) {
      if (option.item.id) {
        this.customerModel.customerId = option.item.id;
        this.customerModel.customerMobile = option.item.phoneNo;
        this.customerModel.customerAppellation = option.item.appellation;
        this.getCustomerInfoById(option.item.id);
        this.getTransactionByCustomerId(option.item.id);
      } else {
        this.customerModel.customerId = '';
        this.customerModel.customerMobile = option.item.phoneNo;
        this.customerModel.customerName = '';
        this.customerModel.totalPoint = 0;
      }
    },
    onSearchChange(searchQuery) {
      if (!searchQuery) {
        searchQuery = '';
      }
      this.customerModel.customerMobile = searchQuery;
      this.optionsCustomer = [];
      this.filteredOptionsCustomer = [...this.optionsCustomer];
      this.debounceInput();
    },
    getListCustomer() {
      const text = this.customerModel.customerMobile
        ? this.customerModel.customerMobile.trim()
        : null;
      if (!text) {
        return;
      }
      ApiService.get(`v1/customers?customerPhone=${text}&customerStatus=1`).then((data) => {
        this.optionsCustomer = data.data?.data?.items || [];
        if (this.optionsCustomer.length > 0) {
          this.filteredOptionsCustomer = [...this.optionsCustomer];
        } else {
          this.filteredOptionsCustomer = [
            { message: 'SĐT không có trong hệ thống', phoneNo: text },
          ];
        }
      });
    },
    async loadOptionCustomers({ action, searchQuery, callback }) {
      if (action === ASYNC_SEARCH) {
        this.customerModel.customerMobile = searchQuery;

        const result = await this.fetchCustomers(searchQuery);

        let optionCustomers = [];
        if (result.data.length) {
          optionCustomers = (result.data || []).map((element) => {
            return {
              id: element.id,
              label: element.phoneNo,
              customLabel: element.fullName,
            };
          });
        } else {
          optionCustomers = [
            {
              id: -1,
              label: searchQuery,
              customLabel: 'SĐT không có trong hệ thống',
              notFound: true,
            },
          ];
        }
        callback(null, optionCustomers);
      }
    },
    fetchCustomers(searchQuery) {
      const textInput = searchQuery ? searchQuery.trim() : null;

      if (!textInput) {
        return;
      }

      const params = {
        phoneNumber: textInput,
        customerStatus: 1,
      };

      return ApiService.query(`v1/customers/get-by-phone`, {
        params,
      }).then((response) => {
        return response.data;
      });
    },
    fetchCity() {
      ApiService.get('city/').then((data) => {
        const cities = data.data.data;
        this.listCity = cloneDeep(cities).reduce((result, element) => {
          if (element.value !== null) {
            result.push({
              id: element.id,
              label: element.name,
              custom: removeAccents(element.name),
            });
          }
          return result;
        }, []);
      });
    },
    getDistrict() {
      ApiService.get(`city/${this.customerModel.customerCity}/district`).then(
        (data) => {
          const districts = data.data.data;
          this.listDistrict = cloneDeep(districts).reduce((result, element) => {
            if (element.value !== null) {
              result.push({
                id: element.id,
                label: element.name,
                custom: removeAccents(element.name),
              });
            }
            return result;
          }, []);
        },
      );
    },
    getWard() {
      ApiService.get(`city/${this.customerModel.customerDistrict}/ward`).then(
        (data) => {
          const wards = data.data.data;
          this.listWard = cloneDeep(wards).reduce((result, element) => {
            if (element.value !== null) {
              result.push({
                id: element.id,
                label: element.name,
                custom: removeAccents(element.name),
              });
            }
            return result;
          }, []);
        },
      );
    },
    getCustomerInfoUpdatedById(customerId) {
      if (!customerId) {
        return;
      }
      ApiService.get(`/v1/customers/${customerId}`).then((response) => {
        const customerInfo = response.data.data;
        const customerName = this.customerModel.customerName
          ? this.customerModel.customerName.trim()
          : null;
        const customerAddress = this.customerModel.customerAddress
          ? this.customerModel.customerAddress.trim()
          : null;
        this.customerModel.customerName = customerName || customerInfo.fullName;
        this.customerModel.customerCity = customerInfo.city;
        this.customerModel.customerWard = customerInfo.ward;
        this.customerModel.customerDistrict = customerInfo.district;
        this.customerModel.customerAddress =
          customerAddress || customerInfo.address;
        this.customerModel.customerType = customerInfo.type;
        this.customerModel.customerAppellation =
          customerInfo.appellation || null;
        this.customerModel.totalPoint = customerInfo.totalPoint || 0;

        if (this.customerModel.customerCity !== null) {
          this.getDistrict();
        }
        if (this.customerModel.customerDistrict !== null) {
          this.getWard();
        }
        this.customerModel.customerLastName = customerInfo.lastName;
      });
    },
    getTransactionByCustomerId(customerId) {
      if (!customerId) {
        return;
      }
      ApiService.get(`v1/customers/transaction/${customerId}`).then(
        (response) => {
          const data = response.data.data;
          this.customerTransaction.orderCount = data.orders.length;
          this.customerTransaction.retailCount = data.retails.length;
          this.customerTransaction.wholesaleCount = data.wholesales.length;
          this.customerTransaction.refundCount = data.refunds.length;
          this.customerTransaction.customerDebt = data.customerDebt;
          this.$emit('fetch-customer-transaction', data);
          const notCompleteStatus = [
            Number(ORDER_STATUS.PREPARED),
            Number(ORDER_STATUS.CONFIRMED),
          ];
          const notCompleteOrders = data.orders.filter((order) =>
            notCompleteStatus.includes(order.status),
          );
          if (!isEmpty(notCompleteOrders)) {
            this.$emit('show-orders', notCompleteOrders);
          }
        },
      );
    },
    viewCustomerTransaction: function () {
      const { href } = this.$router.resolve({
        name: 'update-customer',
        query: {
          id: this.customerModel.customerId,
          phoneNo: this.customerModel.customerMobile,
        },
      });
      window.open(href, '_blank');
    },
    getCustomerInfoById(customerId) {
      if (customerId) {
        ApiService.get(`/v1/customers/${customerId}`).then((response) => {
          const customerInfo = response.data.data;
          this.customerModel.customerName = customerInfo.fullName;
          this.customerModel.customerCity = customerInfo.city;
          this.customerModel.customerWard = customerInfo.ward;
          this.customerModel.customerDistrict = customerInfo.district;
          this.customerModel.customerAddress = customerInfo.address;
          this.customerModel.customerType = customerInfo.type
            ? customerInfo.type
            : '';
          if (this.customerModel.customerCity !== null) {
            this.getDistrict();
          }
          if (this.customerModel.customerDistrict !== null) {
            this.getWard();
          }
          this.customerModel.totalPoint = customerInfo.totalPoint;
          const totalPoint = Number(customerInfo.totalPoint) || 0;
          this.pointText = ` <b>(Tổng điểm:  ${totalPoint})</b>`;
          this.customerModel.customerLastName = customerInfo.lastName;
        });
      }
    },
  },
};
</script>

<style scoped>
.vue-treeselect__input-container {
  padding-top: 0px;
}

.vue-treeselect__control {
  border-radius: 0.28rem;
  border: 1px solid #ced4da;
  height: 2.5rem;
}

.vue-treeselect--has-value .vue-treeselect__multi-value {
  margin-bottom: 2px;
}
.vue-treeselect__tip .vue-treeselect__no-results-tip {
  display: none;
}
.form-group {
  margin-bottom: 0.75rem;
}
.form-group label {
  margin-bottom: 0.25rem;
}
.p {
  margin-bottom: 0.25rem;
}
</style>

<style lang="scss">
#popover-customer {
  .text-link:hover {
    cursor: pointer;
    color: blue;
  }
}
</style>
